export enum FeatureToggle {
  foodstorm = 'rt_foodstorm',
}
